import React, { useState } from "react";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Input from "@material-ui/core/Input";
import { Typography, Checkbox } from "@material-ui/core";

const allColors = ["YELLOW", "WHITE", "ORANGE", "TAN", "PINK", "LIME"];

const GENERATE_TAGS = gql`
  mutation generateTagSet(
    $number: Int!
    $testing: Boolean!
    $colors: [TagColor]!
  ) {
    generateTagSet(number: $number, testing: $testing, colors: $colors) {
      id
      n
      createdAt
      colors
      startTag
    }
  }
`;

const GenerateTagsDialog = ({ open, onClose }) => {
  const [colors, setColors] = useState(JSON.parse(JSON.stringify(allColors)));
  const [testing, setTesting] = useState(false);
  const [n, setN] = useState(100);

  const handleChange = color => event => {
    let newColors;
    if (event.target.checked) {
      newColors = [...colors, color];
    } else {
      newColors = [...colors.filter(c => c !== color)];
    }
    setColors(newColors);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Generate Tags</DialogTitle>
      <DialogContent>
        Once new tags have been generated you will have access to zipped CSV
        files in the Downloads area.
      </DialogContent>
      <DialogContent>
        <Typography variant="body2">Number of Tags (per color)</Typography>
        <FormGroup row>
          <Input type="number" value={n} onChange={e => setN(e.target.value)} />
        </FormGroup>
        <br />
        {/* <Typography variant="body2">Test Tags?</Typography> */}
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={testing}
                onChange={e => setTesting(e.target.checked)}
                color="primary"
              />
            }
            label="Test Tags"
          />
        </FormGroup>
        <br />
        <FormGroup row>
          {allColors.map(color => {
            return (
              <FormControlLabel
                key={color}
                control={
                  <Switch
                    checked={colors.indexOf(color) !== -1}
                    onChange={handleChange(color)}
                    color="primary"
                  />
                }
                label={color}
              />
            );
          })}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Mutation
          mutation={GENERATE_TAGS}
          variables={{ number: parseInt(n), testing, colors }}
        >
          {(mutate, { loading, error }) => {
            if (error) alert("Error generating - " + error.toString());
            return (
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                onClick={() => mutate().then(onClose)}
              >
                Generate {n * colors.length} Tags
              </Button>
            );
          }}
        </Mutation>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateTagsDialog;
